/* ---------------------------------------------------------------------------
 * Shared contract between api, worker, and web. String-literal unions mirror
 * the Prisma enums (apps/api/prisma/schema.prisma) so the browser bundle never
 * imports @prisma/client. If a Prisma enum changes, change it here too — the
 * API's DTO layer is typed against these, so drift fails typecheck there.
 * ------------------------------------------------------------------------- */

/** BullMQ queue names — the api↔worker contract. */
export const QUEUE = {
  agentRun: 'agent-run',
  firefliesSync: 'fireflies-sync',
  driveSync: 'drive-sync',
  githubSync: 'github-sync',
  pdfRender: 'pdf-render',
} as const;

export type UserKind = 'STAFF' | 'CLIENT';
export type CompanyRole = 'ADMIN' | 'MEMBER';

export type RunState =
  | 'REQUESTED'
  | 'PREPARING'
  | 'RUNNING'
  | 'INGESTING'
  | 'DELIVERED'
  | 'FAILED';

/** States in which the web keeps polling GET /runs/:id. */
export const RUN_IN_FLIGHT: readonly RunState[] = ['REQUESTED', 'PREPARING', 'RUNNING', 'INGESTING'];

export type SuggestionKind = 'LEARNING' | 'DATA_GAP' | 'NEXT_ACTION';
export type SuggestionStatus = 'PENDING' | 'APPROVED' | 'DECLINED';
export type ConnectorKind = 'FIREFLIES' | 'GOOGLE_DRIVE' | 'GITHUB';
export type ConnectorStatus = 'CONNECTED' | 'ERROR' | 'DISCONNECTED';
export type ContextFolder = 'MEETINGS' | 'SURVEYS' | 'DATA';
export type KnowledgeScope = 'GLOBAL' | 'COMPANY' | 'WORKSPACE' | 'PROJECT';
export type KnowledgeKind = 'CHARTER' | 'LEARNING';
export type KnowledgeOrigin = 'STAFF_AUTHORED' | 'AGENT_APPROVED';
export type Visibility = 'INTERNAL' | 'CLIENT';
export type Cadence = 'HOURLY' | 'DAILY' | 'WEEKLY';
export type AgentKind = 'agent' | 'orchestrator' | 'playbook';

/** Platform-secret key for the single WarriorLab Claude credential. */
export const CLAUDE_CREDENTIAL_KEY = 'CLAUDE_CREDENTIAL';

export * from './permissions.js';
export * from './routing.js';
